// hook to get userDetails from redux store
import { useSelector } from 'react-redux';

const useUserDetails = () => {
  const user = useSelector((state) => state.authSlice?.userData);
  return user;
};

export default useUserDetails;
// example usage
